"use strict";
var _User_auth0_user;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class User {
    constructor(user) {
        _User_auth0_user.set(this, void 0);
        this.id = user.id;
        this.attributes = user.attributes;
        this.meta = user.meta;
        this.language = user.language;
        this.avatar = user.avatar;
        this.links = user.links;
    }
    set auth0(auth0_user) {
        tslib_1.__classPrivateFieldSet(this, _User_auth0_user, auth0_user, "f");
    }
    get json() {
        return {
            id: this.id,
            attributes: this.attributes,
            meta: this.meta,
            auth0_user: tslib_1.__classPrivateFieldGet(this, _User_auth0_user, "f") || '',
            language: this.language,
            links: this.links,
            avatar: this.avatar,
        };
    }
}
exports.default = User;
_User_auth0_user = new WeakMap();
//# sourceMappingURL=User.js.map